import { render, staticRenderFns } from "./ProjectModal.vue?vue&type=template&id=482a544a&scoped=true"
import script from "./ProjectModal.vue?vue&type=script&lang=js"
export * from "./ProjectModal.vue?vue&type=script&lang=js"
import style0 from "./ProjectModal.vue?vue&type=style&index=0&id=482a544a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482a544a",
  null
  
)

export default component.exports